<template src="./template.html"/>
<style scoped src="./stylesheet.scss" lang="scss"/>

<script>
    export default {
        name: "CategoryCard",
        props: ['category'],
        methods: {
            goToCategoryDetails(id) {
                this.$router.push('/categoria/' + id);
            }
        }
    }
</script>
